import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { X, Filter, Plus } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  countActiveFilters,
  getActiveFilterChips,
  FilterValues,
} from "./filterUtils";

interface FreelancerFilterChipsProps {
  filters: FilterValues;
  onClearKey: (key: string) => void;
  onClearAll: () => void;
  onOpenDrawer: () => void;
  /** false quando o botão de abrir o drawer mora fora (ex.: toolbar da listagem). */
  showOpenButton?: boolean;
  className?: string;
}

export function FreelancerFilterChips({
  filters,
  onClearKey,
  onClearAll,
  onOpenDrawer,
  showOpenButton = true,
  className,
}: FreelancerFilterChipsProps) {
  const chips = getActiveFilterChips(filters);
  const total = countActiveFilters(filters);

  if (!showOpenButton && chips.length === 0) return null;

  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      {showOpenButton && (
        <Button
          variant="outline"
          size="sm"
          onClick={onOpenDrawer}
          className="gap-1"
        >
          {chips.length === 0 ? (
            <>
              <Filter className="h-3.5 w-3.5" />
              Filtros
            </>
          ) : (
            <>
              <Plus className="h-3.5 w-3.5" />
              Mais filtros
            </>
          )}
        </Button>
      )}

      {chips.map((chip) => (
        <Badge
          key={chip.key}
          variant="secondary"
          className="px-2 py-1 gap-1.5 cursor-pointer hover:bg-secondary/80"
          onClick={onOpenDrawer}
          title="Abrir filtros para editar"
        >
          <span className="font-medium">{chip.label}:</span>
          <span className="text-muted-foreground">{chip.summary}</span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onClearKey(chip.key);
            }}
            className="ml-0.5 hover:text-destructive"
            aria-label={`Remover filtro ${chip.label}`}
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      ))}

      {total > 0 && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearAll}
          className="text-muted-foreground hover:text-destructive gap-1"
        >
          <X className="h-3.5 w-3.5" />
          Limpar tudo ({total})
        </Button>
      )}
    </div>
  );
}
